module.exports = __webpack_public_path__ + "img/eiza_gonzales.65afc63c.jpg";